module.exports = __webpack_public_path__ + "img/pic02_index.20f73ddb.png";